import React, { useContext, useEffect, useState } from 'react';
import { TramitexApi } from '../apis/ITramitexApi';
import { useHost } from '@ioip/core/lib';
import { Tramitex } from '../types';
const _context = React.createContext(null);
export const TramitexProvider = (props) => {
    const context = new TramitexApi(props.apis);
    return React.createElement(_context.Provider, { value: context }, props.children);
};
export const useTramitex = (props = {}) => {
    const host = useHost();
    const context = useContext(_context);
    const [state, setState] = useState([true, null]);
    useEffect(() => {
        const instance = new Tramitex({ context: host.context, api: context });
        Promise.all([
            props.companyTypes ? instance.loadCompanyTypesAsync() : Promise.resolve([]),
            props.contactTypes ? instance.loadContactTypesAsync() : Promise.resolve([]),
            props.disabilities ? instance.loadDisabilitiesAsync() : Promise.resolve([]),
            props.educationLevels ? instance.loadEducationLevelsAsync() : Promise.resolve([]),
            props.ethnicGroups ? instance.loadEthnicGroupsAsync() : Promise.resolve([]),
            props.genders ? instance.loadGendersAsync() : Promise.resolve([]),
            props.identificationTypes ? instance.loadIdentificationTypesAsync() : Promise.resolve([]),
            props.preferentialTreatment ? instance.loadPreferentialTreatmentsAsync() : Promise.resolve([]),
            props.procedures ? instance.loadProceduresAsync() : Promise.resolve([]),
            props.professions ? instance.loadProfessionsAsync() : Promise.resolve([]),
            props.ageRanges ? instance.loadAgeRangesAsync() : Promise.resolve([]),
            props.orientationSectors ? instance.loadOrientationSectorsAsync() : Promise.resolve([])
        ]).then(() => {
            setState([false, instance]);
        });
    }, []);
    if (context == null)
        throw new Error('No es posible acceder al contexto de tramitex, verifique que el componente esté dentro del proveedor <TramitexProvider />');
    return state;
};
